// components/ProtectedRoute.jsx - UPDATED VERSION
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children, requiredPermission = null }) => {
  const { currentUser, loading, hasPermission } = useAuth();

  // Show loading while checking authentication
  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center min-vh-100">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  // If not authenticated, redirect to login
  if (!currentUser) {

    return <Navigate to="/login" replace />;
  }

  // If a specific permission is required and user doesn't have it
  if (requiredPermission) {
    const hasRequiredPermission = Array.isArray(requiredPermission) 
      ? requiredPermission.some(permission => hasPermission(permission))
      : hasPermission(requiredPermission);

    if (!hasRequiredPermission) {

      return (
        <div className="d-flex justify-content-center align-items-center min-vh-100">
          <div className="text-center">
            <h5>Accès Refusé</h5>
            <p className="text-muted">
              Vous n'avez pas les permissions nécessaires pour accéder à cette page.
            </p>
            <button 
              className="btn btn-primary mt-3"
              onClick={() => window.history.back()}
            >
              Retour
            </button>
          </div>
        </div>
      );
    }
  }


  return children;
};

export default ProtectedRoute;